import React from "react";
import Floor_Plans_Image03 from "../PicsForPages/FloorPlaneImage03.webp";
import Floor_Plans_Image04 from "../PicsForPages/FloorPlaneImage04.webp";
import Floor_Plans_Image05 from "../PicsForPages/FloorPlaneImage05.webp";
import UseScrollAnimation from "../Elements/ScrollAnimation";

function Floorplans() {
  UseScrollAnimation(); // ✅ just call it

  return (
    <div className="Available_Floor_PlansParent">
      <div className="Available_Floor_PlansBox">
        <div className="Available_Floor_PlansBoxHeading">
          <span className="Available_Floor_PlansBoxHeadingWord animate-top">
            Available Floor Plans
          </span>
          <span className="Available_Floor_PlansBoxHeadingLine animate-top"></span>
        </div>
        <div className="Available_Floor_PlansCantentParent">
          {/* <div className="Available_Floor_PlansCantentBox">
            <div className="Available_Floor_PlansCantentBoxPara">
              <div className="Available_Floor_PlansCantentBoxPara_Heading">
                Redbud
              </div>
              <div className="Available_Floor_PlansCantentBoxPara_SubHeading">
                1 Bedroom / 1 Bathroom / 1,055 SQ.FT
              </div>
              <div className="Available_Floor_PlansCantentBoxPara_ContentBox">
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  Welcome to the Redbud floor plan, where stylish design meets
                  effortless living. Spanning 1,055 square feet, this
                  one-bedroom, one-bathroom abode offers a perfect blend of
                  comfort, elegance, and modern living.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  The moment you step inside, you're welcomed by a spacious,
                  light-filled living area that invites you to relax, entertain,
                  and enjoy. The open-plan layout encourages natural flow
                  throughout the space, ensuring a comfortable environment for
                  both daily life and hosting get-togethers.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  A state-of-the-art kitchen awaits you, equipped with modern
                  appliances and designed to inspire your culinary adventures.
                  Its efficient design is complemented by ample counter space
                  and plenty of storage, resulting in a kitchen as functional as
                  it is beautiful.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  The expansive master bedroom, your private retreat, is a space
                  that encourages relaxation. It offers ample room for your
                  king-sized bed and additional furniture, allowing you to
                  personalize the space to fit your taste. The adjoining
                  bathroom, featuring premium fixtures and fittings, offers a
                  serene space to unwind and refresh.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  Step outside to your private balcony or patio, an ideal spot
                  to enjoy a morning coffee or an evening wind-down, all while
                  soaking in the serene sights and sounds of Cornelius Woods.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  Experience luxury, convenience, and thoughtful design in every
                  detail of your Redbud home. The perfect space to call your own
                  within Cornelius Woods' active adult retirement community.
                </span>
              </div>
            </div>
            <div className="Available_Floor_PlansImageDiv">
              <img fetchPriority="high"
                  loading="eager"
                src={Floor_Plans_Image02}
                alt="Available_Floor_PlansImage"
                className="Available_Floor_PlansImageDivPic"
              />
            </div>
          </div> */}
          <div className="Available_Floor_PlansCantentBox">
            <div className="Available_Floor_PlansCantentBoxPara">
              <div className="Available_Floor_PlansCantentBoxPara_Heading animate-top">
                Camilia
              </div>
              <div className="Available_Floor_PlansCantentBoxPara_SubHeading animate-top">
                1 Bedroom / 1.5 Bathroom / 1,475 SQ.FT
              </div>
              <div className="Available_Floor_PlansCantentBoxPara_ContentBox">
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Step into Camilia, a luxurious haven of comfort and
                  tranquility designed for the discerning individual. Offering a
                  spacious 1,475 square feet of living space, this elegantly
                  appointed one-bedroom, one-bathroom floor plan blends modern
                  aesthetics with practical design.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  As you walk through the front door, the generous open-plan
                  living and dining area welcomes you home. Bathed in natural
                  light, it's the perfect space for hosting guests, savoring
                  quiet moments or simply enjoying day-to-day living. The
                  high-quality finishings and refined details add a touch of
                  elegance to the expansive living space.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  The gourmet kitchen, equipped with state-of-the-art
                  appliances, is designed for those who appreciate the art of
                  cooking. With ample counter and storage space, it brings
                  functionality and style together.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Retreat to the serene comfort of the spacious master bedroom
                  that has been crafted keeping your utmost comfort in mind. The
                  adjoining upscale bathroom, complete with high-end fixtures,
                  offers a personal spa-like experience, promising relaxation
                  after a long day.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Enjoy your morning coffee or relish a good book on the private
                  patio/balcony, your personal outdoor oasis.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Welcome to Camilia, a perfect blend of comfort, style, and
                  space – your private sanctuary in the heart of Cornelius
                  Woods.
                </span>
              </div>
            </div>
            <div className="Available_Floor_PlansImageDiv">
              <img
                fetchPriority="high"
                loading="eager"
                src={Floor_Plans_Image03}
                alt="Available_Floor_PlansImage"
                className="Available_Floor_PlansImageDivPic animate-top"
              />
            </div>
          </div>{" "}
          {/* <div className="Available_Floor_PlansCantentBox">
            <div className="Available_Floor_PlansCantentBoxPara">
              <div className="Available_Floor_PlansCantentBoxPara_Heading">
                Sweetbay
              </div>
              <div className="Available_Floor_PlansCantentBoxPara_SubHeading">
                2 Bedrooms / 2 Bathrooms / 1,255 SQ.FT
              </div>
              <div className="Available_Floor_PlansCantentBoxPara_ContentBox">
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  Introducing Sweetbay, a stunning fusion of elegance, comfort,
                  and thoughtful design. This spacious 2-bedroom, 2-bathroom
                  floor plan spans 1,255 square feet, offering the perfect
                  setting for a sophisticated, relaxed lifestyle within
                  Cornelius Woods.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  As you enter, you're greeted by an open-concept living and
                  dining area that radiates with natural light. Whether you're
                  hosting an intimate gathering or enjoying a quiet evening,
                  this multifunctional space caters to all your needs.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  The modern kitchen, a chef's delight, is fitted with
                  state-of-the-art appliances, ample storage, and extensive
                  counter space. Prepare your favorite meals or explore new
                  recipes in this aesthetically pleasing and practical culinary
                  space.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  The Sweetbay layout offers two luxurious bedrooms, each an
                  oasis of calm. The master suite boasts a spacious layout and
                  an adjoining upscale bathroom, providing a private retreat to
                  relax and rejuvenate. The second bedroom, equally
                  well-appointed, offers the flexibility to serve as a guest
                  room, study, or hobby room.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  The additional bathroom ensures convenience and privacy for
                  guests or household members, mirroring the luxury fixtures and
                  elegant design found throughout the home.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  Step out onto your private patio or balcony, the perfect nook
                  for your morning coffee or an evening sip, all while enjoying
                  the peaceful surroundings of Cornelius Woods.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine">
                  Discover the Sweetbay floor plan, a harmonious blend of space,
                  style, and comfort in Cornelius Woods - an active 55+ adult
                  retirement community.
                </span>
              </div>
            </div>
            <div className="Available_Floor_PlansImageDiv">
              <img fetchPriority="high"
                  loading="eager"
                src={Floor_Plans_Image01}
                alt="Available_Floor_PlansImage"
                className="Available_Floor_PlansImageDivPic"
              />
            </div>
          </div>{" "} */}
          <div className="Available_Floor_PlansCantentBox">
            <div className="Available_Floor_PlansImageDiv">
              <img
                fetchPriority="high"
                loading="eager"
                src={Floor_Plans_Image05}
                alt="Available_Floor_PlansImage"
                className="Available_Floor_PlansImageDivPic animate-top"
              />
            </div>
            <div className="Available_Floor_PlansCantentBoxPara">
              <div className="Available_Floor_PlansCantentBoxPara_Heading animate-top">
                Tupelo
              </div>
              <div className="Available_Floor_PlansCantentBoxPara_SubHeading animate-top">
                2 Bedrooms / 2 Bathrooms / 1,675 SQ.FT
              </div>
              <div className="Available_Floor_PlansCantentBoxPara_ContentBox">
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Welcome to Tupelo, a spacious sanctuary that epitomizes the
                  fusion of comfort and luxury. Spread over 1,675 square feet,
                  this 2-bedroom, 2-bathroom layout offers an abundance of
                  living space and a wealth of natural light in the heart of the
                  Cornelius Woods community.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Upon entrance, the open-concept living and dining area invites
                  you in, offering ample space for relaxation, entertainment,
                  and making memories. The inviting, warm ambiance seamlessly
                  ties together your daily routines and special occasions.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Adjacent to this is your modern kitchen, featuring
                  state-of-the-art appliances, abundant storage, and expansive
                  counter space. The thoughtful design brings together style and
                  practicality, offering the perfect canvas for your culinary
                  masterpieces.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  In the Tupelo layout, you'll find two sizable bedrooms. The
                  master suite serves as your private sanctuary, complete with a
                  luxurious adjoining bathroom that promises relaxation and
                  rejuvenation. The second bedroom, spacious and versatile, can
                  be tailored to your needs, whether as a guest room, a home
                  office, or a personal hobby space.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  An additional upscale bathroom is featured, offering
                  convenience and maintaining the elegance and sophistication
                  consistent throughout the home.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Step outside to your private balcony or patio, a peaceful
                  retreat for a morning coffee, an evening read, or simply
                  soaking in the serene views of Cornelius Woods.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  The Tupelo floor plan offers a refined lifestyle, blending
                  style, comfort, and convenience in the heart of our 55+ active
                  adult retirement community, Cornelius Woods.
                </span>
              </div>
            </div>
          </div>{" "}
          <div className="Available_Floor_PlansCantentBox">
            <div className="Available_Floor_PlansCantentBoxPara">
              <div className="Available_Floor_PlansCantentBoxPara_Heading animate-top">
                Holly
              </div>
              <div className="Available_Floor_PlansCantentBoxPara_SubHeading animate-top">
                2 Bedrooms / 2 Bathrooms / 1,750 SQ.FT
              </div>
              <div className="Available_Floor_PlansCantentBoxPara_ContentBox">
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Step into Holly, a haven of luxury and serenity spanning 1,750
                  square feet, perfectly suited for the discerning resident.
                  This spacious 2-bedroom, 2-bathroom layout within Cornelius
                  Woods combines sophistication with functionality.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Upon entering, you are welcomed by an expansive, open-concept
                  living and dining space flooded with natural light. It's an
                  inviting space that caters to both grand entertaining and
                  intimate family moments.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  The adjacent gourmet kitchen is a modern masterpiece. Equipped
                  with top-of-the-line appliances and abundant storage, it
                  offers an inspiring space for culinary creativity. The ample
                  counter space and thoughtful layout make cooking a delight,
                  not a chore.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  The Holly floor plan showcases two generously sized bedrooms.
                  The master suite, with its adjoining upscale bathroom,
                  provides a tranquil retreat to rest and recharge. The second
                  bedroom, equally well-appointed, can be personalized to serve
                  as a guest room, an office, or a hobby space.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  The additional luxurious bathroom ensures the utmost
                  convenience for guests or other members of the household,
                  perfectly echoing the premium quality and aesthetic of the
                  home.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  An added gem is your private patio or balcony, an ideal
                  sanctuary to start your day with a refreshing morning cup or
                  end it with a serene evening gaze at the stars, all set
                  against the tranquil backdrop of Cornelius Woods.
                </span>
                <span className="Available_Floor_PlansCantentBoxPara_ContentBoxLine animate-top">
                  Embrace a lifestyle of comfort, style, and space with the
                  Holly floor plan, your beautiful home in Cornelius Woods, the
                  premier 55+ active adult retirement community.
                </span>
              </div>
            </div>
            <div className="Available_Floor_PlansImageDiv">
              <img
                fetchPriority="high"
                loading="eager"
                src={Floor_Plans_Image04}
                alt="Available_Floor_PlansImage"
                className="Available_Floor_PlansImageDivPic animate-top"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Floorplans;
